import {lazy} from 'react';

export const UnrestrictedHtmlLazy = lazy(() => import(/* webpackChunkName: "unrestrictedHtml" */ '.'));
